import React from 'react'
import { mount } from 'enzyme'
import PerPage from '../features/dashboard/PerPage'

describe('<PerPage />', () => {
  const noop = () => {}
  let wrapper, props
  it('should render without crashing', () => {
    mount(<PerPage totalRecords={10} perPage={10} changePerPage={noop} />)
  })
  it('should display the total number of records', () => {
    props = {
      totalRecords: 200,
      perPage: 10,
      changePerPage: noop
    }
    wrapper = mount(<PerPage {...props} />)
    const perPageSelectors = wrapper.find('PerPage__PerPageSelector') // Find the display component within PerPage
    expect(perPageSelectors.at(perPageSelectors.length - 1).text()).toEqual('200') // Total records is always the last PerPageSelector
  })
  describe('when there are ten or fewer records', () => {
    beforeEach(() => {
      props = {
        totalRecords: 10,
        perPage: 10,
        changePerPage: noop
      }
      wrapper = mount(<PerPage {...props} />)
    })
    it('should only render one per page selector with the number 10', () => {
      expect(wrapper.find('PerPage__PerPageSelector').at(0).text()).toEqual('10')
    })
  })
  describe('when there are more than 10 and fewer than 20 records', () => {
    beforeEach(() => {
      props = {
        totalRecords: 15,
        perPage: 10,
        changePerPage: noop
      }
      wrapper = mount(<PerPage {...props} />)
    })
    it('should render a per page selector for both 10 and 20', () => {
      const perPageSelectors = wrapper.find('PerPage__PerPageSelector')
      expect(perPageSelectors.at(0).text()).toEqual('10')
      expect(perPageSelectors.at(1).text()).toEqual('20')
    })
  })
  describe('when there are more than 20 and fewer than 50 records', () => {
    beforeEach(() => {
      props = {
        totalRecords: 25,
        perPage: 10,
        changePerPage: noop
      }
      wrapper = mount(<PerPage {...props} />)
    })
    it('should render a per page selector for 10, 20, and 50', () => {
      const perPageSelectors = wrapper.find('PerPage__PerPageSelector')
      expect(perPageSelectors.at(0).text()).toEqual('10')
      expect(perPageSelectors.at(1).text()).toEqual('20')
      expect(perPageSelectors.at(2).text()).toEqual('50')
    })
  })
  describe('when there are more than 50 records', () => {
    beforeEach(() => {
      props = {
        totalRecords: 51,
        perPage: 10,
        changePerPage: noop
      }
      wrapper = mount(<PerPage {...props} />)
    })
    it('should render a per page selector for 10, 20, 50, and 100', () => {
      const perPageSelectors = wrapper.find('PerPage__PerPageSelector')
      expect(perPageSelectors.at(0).text()).toEqual('10')
      expect(perPageSelectors.at(1).text()).toEqual('20')
      expect(perPageSelectors.at(2).text()).toEqual('50')
      expect(perPageSelectors.at(3).text()).toEqual('100')
    })
  })
})
